import React from "react";
import { Container } from "react-bootstrap";

const OmlycloHCP = ({ shouldHideDiv, collapseText, isiTextRef, readLess }) => {
  return (
    <>
      <div
        className={`isi-text-sticky isi-text ${shouldHideDiv ? "d-none" : ""}`}
      >
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex">
            <button
              className="isi-text-open open omlyclo"
              onClick={collapseText}
            ></button>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="omlyclo-color">
                  IMPORTANT SAFETY INFORMATION
                </strong>
              </p>
              <p>
                <strong>
                  OMLYCLO<sup>&reg;</sup> may cause serious side effects,
                  including:
                </strong>
              </p>
              <p>
                <strong>Severe allergic reactions (anaphylaxis)</strong> can
                happen when you receive OMLYCLO. The reaction can occur after
                the first dose, or after many doses. It may also occur right
                after an OMLYCLO injection or days later. Anaphylaxis is a
                life-threatening condition and can lead to death. Go to the
                nearest emergency room right away if you have any of these
                symptoms of an allergic reaction:
              </p>
              <ul>
                <li>
                  wheezing, shortness of breath, cough, chest tightness, or
                  trouble breathing
                </li>
                <li>
                  low blood pressure, dizziness, fainting, rapid or weak
                  heartbeat, anxiety, or feeling of &ldquo;impending doom&rdquo;
                </li>
              </ul>
            </div>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="omlyclo-color">INDICATIONS</strong>
              </p>
              <p>
                OMLYCLO<sup>&reg;</sup> (omalizumab-igec) is an injectable
                prescription medicine used to treat:
                <ul>
                  <li>
                    <strong>moderate to severe persistent asthma</strong> in
                    people 6 years of age and older whose asthma symptoms are
                    not well controlled with asthma medicines called inhaled
                    corticosteroids. A skin or blood test is performed to see if
                    you have allergies to year-round allergens. It is not known
                    if OMLYCLO is safe and effective in people with asthma under
                    6 years of age.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </Container>
      </div>

      <div className="isi-text" ref={isiTextRef}>
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex">
            <button
              onClick={readLess}
              className="isi-text-open closed omlyclo"
            ></button>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="omlyclo-color">
                  IMPORTANT SAFETY INFORMATION
                </strong>
              </p>
              <p>
                <strong>
                  OMLYCLO<sup>&reg;</sup> may cause serious side effects,
                  including:
                </strong>
              </p>
              <p>
                <strong>Severe allergic reactions (anaphylaxis)</strong> can
                happen when you receive OMLYCLO. The reaction can occur after
                the first dose, or after many doses. It may also occur right
                after an OMLYCLO injection or days later. Anaphylaxis is a
                life-threatening condition and can lead to death. Go to the
                nearest emergency room right away if you have any of these
                symptoms of an allergic reaction:
              </p>
              <ul>
                <li>
                  wheezing, shortness of breath, cough, chest tightness, or
                  trouble breathing
                </li>
                <li>
                  low blood pressure, dizziness, fainting, rapid or weak
                  heartbeat, anxiety, or feeling of &ldquo;impending doom&rdquo;
                </li>
                <li>flushing, itching, hives, or feeling warm</li>
                <li>
                  swelling of the throat or tongue, throat tightness, hoarse
                  voice, or trouble swallowing
                </li>
              </ul>
              <p>
                Your healthcare provider will monitor you closely for symptoms
                of an allergic reaction while you are receiving OMLYCLO and for
                a period of time after treatment is initiated. Your healthcare
                provider should talk to you about getting medical treatment if
                you have symptoms of an allergic reaction.
              </p>
              <p>
                <strong>Cancer. </strong>
                Cases of cancer were observed in some people who received
                OMLYCLO.
              </p>
              <p>
                <strong>Inflammation of your blood vessels. </strong>
                Rarely, this can happen in people with asthma who receive
                OMLYCLO. Tell your healthcare provider right away if you have:
                rash, chest pain, shortness of breath, a feeling of pins and
                needles or numbness of your arms or legs.
              </p>
              <p>
                <strong>Fever, muscle aches, and rash.</strong> Some people get
                these symptoms 1 to 5 days after receiving an OMLYCLO injection.
                If you have any of these symptoms, tell your healthcare
                provider.
              </p>
              <p>
                <strong>Parasitic infection. </strong>
                Some people who are at a high risk for parasite (worm)
                infections get a parasite infection after receiving OMLYCLO.
                Your healthcare provider can test your stool to check if you
                have a parasite infection.
              </p>
              <p>
                <strong>Heart and circulation problems. </strong>
                Some people who receive OMLYCLO have had chest pain, heart
                attack, blood clots in the lungs or legs, or temporary symptoms
                of weakness on one side of the body, slurred speech, or altered
                vision.
              </p>
              <p>
                <strong>
                  Before receiving OMLYCLO, tell your healthcare provider about
                  all of your medical conditions, including if you:
                </strong>
              </p>
              <ul>
                <li>have sudden breathing problems (bronchospasm).</li>
                <li>
                  have ever had a severe allergic reaction called anaphylaxis.
                </li>
                <li>have or have had a parasitic infection.</li>
                <li>have or have had cancer.</li>
                <li>
                  are pregnant or plan to become pregnant, are breastfeeding or
                  plan to breastfeed. It is not known if OMLYCLO may harm your
                  unborn baby or if it passes into your breast milk. Talk with
                  your healthcare provider about the best way to feed your baby
                  while you receive and use OMLYCLO.
                </li>
              </ul>
              <p>
                <strong>
                  Tell your healthcare provider about all the medicines you
                  take,
                </strong>{" "}
                including prescription and over-the-counter medicines, vitamins,
                and herbal supplements.
              </p>
              <p>
                <strong>Do not receive and use OMLYCLO if</strong> you are
                allergic to omalizumab products or any of the ingredients in
                OMLYCLO.
              </p>
              <p>
                <strong>The most common side effects of OMLYCLO:</strong>
              </p>
              <p>
                <strong>
                  In adults and children 12 years of age and older with asthma:
                </strong>{" "}
                joint pain especially in your arms and legs, dizziness, feeling
                tired, itching, skin rash, bone fractures, and pain or discomfort
                of your ears.
              </p>
              <p>
                <strong>
                  In children 6 to less than 12 years of age with asthma:{" "}
                </strong>
                swelling of the inside of your nose, throat, or sinuses,
                headache, fever, throat infection, ear infection, abdominal
                pain, stomach infection, and nose bleeds.
              </p>
              <p>
                <strong>
                  In adults with chronic rhinosinusitis with nasal polyps:
                </strong>{" "}
                headache, injection site reactions, joint pain, upper abdominal
                pain, and dizziness.
              </p>
              <p>
                <strong>
                  In people with chronic spontaneous urticaria:{" "}
                </strong>
                nausea, headaches, swelling of the inside of your nose, throat
                or sinuses, cough, joint pain, and upper respiratory tract
                infection.
              </p>
              <p>
                <strong>In people with food allergy:</strong> injection site
                reactions and fever.
              </p>
              <p>
                These are not all the possible side effects of OMLYCLO. Call
                your doctor for medical advice about side effects. You may
                report side effects to FDA at 1-800-FDA-1088.
              </p>
            </div>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="omlyclo-color">INDICATIONS</strong>
              </p>
              <p>
                OMLYCLO<sup>&reg;</sup> (omalizumab-igec) is an injectable
                prescription medicine used to treat:
                <ul>
                  <li>
                    <strong>moderate to severe persistent asthma</strong> in
                    people 6 years of age and older whose asthma symptoms are
                    not well controlled with asthma medicines called inhaled
                    corticosteroids. A skin or blood test is performed to see if
                    you have allergies to year-round allergens. It is not known
                    if OMLYCLO is safe and effective in people with asthma under
                    6 years of age.
                  </li>
                  <li>
                    <strong>
                      chronic rhinosinusitis with nasal polyps (CRSwNP)
                    </strong>{" "}
                    in people 18 years of age and older when medicines to
                    treat CRSwNP called nasal corticosteroids have not worked
                    well enough. It is not known if OMLYCLO is safe and
                    effective in people with CRSwNP under 18 years of age.
                  </li>
                  <li>
                    <strong>food allergy</strong> in people 1 year of age and
                    older to reduce allergic reactions that may occur after
                    accidentally eating one or more foods to which you are
                    allergic. While taking OMLYCLO you should continue to avoid
                    all foods to which you are allergic. It is not known if
                    OMLYCLO is safe and effective in people with food allergy
                    under 1 year of age.
                  </li>
                  <li>
                    <strong>chronic spontaneous urticaria</strong> (CSU,
                    previously referred to as chronic idiopathic urticaria
                    (CIU), chronic hives without a known cause) in people 12
                    years of age and older who continue to have hives that are
                    not controlled with H1 antihistamine treatment. It is not
                    known if OMLYCLO is safe and effective in people with CSU
                    under 12 years of age.
                  </li>
                </ul>
                <strong>OMLYCLO should not be used for </strong>the emergency
                treatment of any allergic reactions, including anaphylaxis, to
                treat other forms of hives, or sudden breathing problems.
              </p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default OmlycloHCP;
